import { mapCustomerDataToCustomer } from "@repo/api";
import { logError } from "@repo/utils";

export const getCustomerDetails = async (market: string, language: string) => {
  try {
    if (window.salja?.customerProfile?.getCustomerData) {
      const customer = await window.salja.customerProfile.getCustomerData();
      return mapCustomerDataToCustomer(
        market,
        language,
        customer?.customerData
      );
    }
  } catch (error) {
    logError(error);
  }

  return undefined;
};
